// extracted by mini-css-extract-plugin
export default {"blockPreloder":"preloder_blockPreloder__1Xl3l","pic":"preloder_pic__iLF3+"};